angular.module('cfn').directive('cfnCoreCropSequenceDisplay', [
  '$rootScope',
  '$http',
  '$log',
  function($rootScope, $http, $log) {
    return {
      restrict: 'E',
      scope: {
        cropSequence: '=',
        entity: '='
      },
      link: function(scope, element, attrs) {
        scope.$watch('cropSequence.id', function() {
          $log.debug('Cropsequence change', scope.cropSequence);
          scope.cropSequenceList = null;
          if (scope.cropSequence) {
            $http
              .get(
                '/365FarmNet/rest/core/cropsequence/' + scope.cropSequence.id
              )
              .then(function(response) {
                //console.debug("received crop sequence",response);
                scope.cropSequenceList = response.data.cropSequence_crops;
              });
          }
        });
        scope.$rootScope = $rootScope;
      },
      templateUrl: require('./cfn-core-crop-sequence-display.tpl.html')
    };
  }
]);
